<template lang="pug">
  y-dialog(v-model="showModal" :fullscreen="$vuetify.breakpoint.xsOnly" max-width="600" persistent scrollable content-class="round-3xl")
    v-card
      v-card-title.px-4.py-3
        v-row(no-gutters align="center")
          v-col(cols="10" offset="1")
            div.text-xl.font-bold.neutral700--text.text-center {{ $t('embed_code') }}
          v-col(cols="1" align="right")
            v-btn.ml-n3(text icon @click="showModal = !showModal")
              v-icon(color="neutral700" :size="24") mdi-close

      v-divider
      v-card-text(:class="$vuetify.breakpoint.xsOnly ? 'pa-4' : 'pa-8'")
        div.text-lg.font-medium.neutral700--text {{ $t('copy_paste_embed') }}
        v-card.neutral700.white--text.pa-3.mt-4(flat style="white-space: pre-wrap;")
          div.text-sm.font-normal {{ showCode }}
        div(ref="copy")

      v-divider
      v-card-actions.py-4(:class="$vuetify.breakpoint.xsOnly ? 'px-4' : 'px-8'")
        v-spacer
        v-btn.text-none(color='white', text @click='showModal = false')
          .text-md.font-bold.primary400--text {{ $t('cancel') }}
        v-btn.button-md.ml-6(color='textColorAccent' depressed dark :loading="isLoading" @click='clickCopyLink') {{ $t('copy_code') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'SendMessageDialog',
  props: ['open', 'copyCode', 'showCode'],
  data: () => ({
    isLoading: false,
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showModal: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions(['showMessage']),
    clickCopyLink () {
      let container = this.$refs.copy
      this.$copyText(this.copyCode, container)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.content_copied_to_clipboard')])
        })
    },
  }
}
</script>

<style scoped>
.message-preview-border {
  border: var(--v-basic500) solid 1px;
}
</style>